import axiosInstance from "services/AxiosInstance";

import { BuyspacePayload, CreateBuyspaceResponse } from "../types";

export const postBuyspaceService = async (payload: BuyspacePayload): Promise<CreateBuyspaceResponse> => {
  const response = await axiosInstance.post("buyspace", payload);
  return response.data;
};
